<template>
	<div class="skyTiming">
		<div class="skyTiming" v-for="(item, index) in timingValue" :key="index">
			<div class="timingSelects">
				<!-- <span class="margin_right_20">设置周期</span> -->
				<el-select
					v-model="item.dayOfWeek"
					:multiple="multiple"
					collapse-tags
					class="margin_right_20"
					placeholder="请选择"
				>
					<el-option v-for="item in week" :key="item.code" :label="item.name" :value="item.dayOfWeek">
					</el-option>
				</el-select>
			</div>
			<div>
				<!-- <el-tooltip :content="content" placement="top" effect="light">
					<i class="iconfont el-icon-question">创建时间：</i>
				</el-tooltip> -->
				<el-time-select
					v-model="item.startHour"
					:format="valueFormat"
					:value-format="valueFormat"
					:picker-options="{
						start: '00:00',
						step: '00:15',
						end: '23:45'
					}"
					class="margin_right_20"
					placeholder="开始时间"
				>
				</el-time-select>
			</div>
			<span class="margin_right_20">至</span>
			<div class="margin_right_20">
				<!-- <el-tooltip content="计划将在该时间将计划开启" placement="top" effect="light">
					<i class="iconfont el-icon-question">运行时间：</i>
				</el-tooltip> -->
				<el-time-select
					v-model="item.endHour"
					:format="valueFormat"
					:value-format="valueFormat"
					:picker-options="{
						start: '00:00',
						step: '00:15',
						end: '23:45'
					}"
					placeholder="结束时间"
				>
				</el-time-select>
			</div>
			<el-button
				v-show="timingValue.length - 1 == index"
				plain
				icon="el-icon-plus"
				@click="add"
				class="margin_right_10"
			></el-button>
			<el-button class="margin_left_0" plain icon="el-icon-close" @click="del(index)"></el-button>
		</div>
	</div>
</template>
<script>
import googleads from '@/backend/services/googleAds/googleAds.js';
export default {
	name: 'skyTiming',
	props: {
		value: {
			default() {
				return [
					{
						dayOfWeek: '',
						startHour: '',
						endHour: '',
						resourceName: null
					}
				];
			}
		},
		code: {
			type: String,
			default: ''
		},
		multiple: {
			type: Boolean,
			default: false
		},
		content: {
			type: String,
			default: '计划将在该时间同步至头条后台且为关闭状态'
		}
	},
	data() {
		return {
			week: [
				{
					name: '所有日期',
					dayOfWeek: 'UNSPECIFIED'
				},
				{
					name: '星期一到星期五',
					dayOfWeek: 'UNKNOWN'
				},
				{
					name: '星期一',
					dayOfWeek: 'MONDAY'
				},
				{
					name: '星期二',
					dayOfWeek: 'TUESDAY'
				},
				{
					name: '星期三',
					dayOfWeek: 'WEDNESDAY'
				},
				{
					name: '星期四',
					dayOfWeek: 'THURSDAY'
				},
				{
					name: '星期五',
					dayOfWeek: 'FRIDAY'
				},
				{
					name: '星期六',
					dayOfWeek: 'SATURDAY'
				},
				{
					name: '星期日',
					dayOfWeek: 'SUNDAY'
				},
			],
			timingValue: [],
			valueFormat: 'HH:mm'
		};
	},
	watch: {
		value: {
			handler(val) {
				this.timingValue = val;
			},
			immediate: true,
			deep: true
		},
		code: {
			handler: function(val) {
				if (val) {
					this.getCode(val);
				}
			},
			immediate: true
		}
	},
	methods: {
		add() {
			this.timingValue.push({
				dayOfWeek: '',
				startHour: '',
				endHour: '',
				resourceName: null
			});
		},
		del(index) {
			if (this.timingValue.length == 1) {
				return false;
			}
			this.timingValue.splice(index, 1);
		},
		async getCode(code) {
			let res = await googleads.codeFun(code);
			this.week = res.data;
		}
	}
};
</script>
<style lang="scss">
.skyTiming {
	.skyTiming {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
		.el-date-editor.el-input,
		.el-date-editor.el-input__inner {
			width: 120px;
		}
		.timingSelects .el-select {
			width: 140px;
		}
	}
	.margin_right_20 {
		margin-right: 20px;
	}
	.margin_right_10 {
		margin-right: 10px;
	}
	.margin_left_0 {
		margin-left: 0;
	}
}
</style>
